import { render, staticRenderFns } from "./permission-test.vue?vue&type=template&id=23afbc66&scoped=true&"
import script from "./permission-test.vue?vue&type=script&lang=js&"
export * from "./permission-test.vue?vue&type=script&lang=js&"
import style0 from "./permission-test.vue?vue&type=style&index=0&id=23afbc66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23afbc66",
  null
  
)

export default component.exports